/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-31 10:05:13                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-10-31 10:14:48                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
*/

/* Imports */
import { Link } from "react-router-dom";
import { t } from "i18next";
import { Typography } from "@material-tailwind/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
/***/

export default function NotFound() {
  return (
    <div className="h-screen flex items-center justify-center flex-col gap-4">
      <Typography variant="h3">
        Page not found...
      </Typography>
      
      <Link to="/" className="flex items-center gap-3 hover:underline">
        {t("returnToDashboard")}
        <ArrowRightIcon className="w-[18px]"/>
      </Link>
    </div>
  );
}
